import {Component} from '@angular/core';
import {ProductionScheduleState} from '@domain/production-schedule/production-schedule-state';
import {ProductionScheduleStatus} from '@domain/production-schedule/production-schedule-status.enum';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ProductionScheduleOverviewStatusRendererParams} from './production-schedule-overview-status-renderer-params.interface';

@Component({
  templateUrl: './production-schedule-overview-status.component.html'
})
export class ProductionScheduleOverviewStatusComponent implements ICellRendererAngularComp {
  public withNewIcons = false;
  public withSmallSize = false;
  public productionScheduleStatus: ProductionScheduleStatus;
  public productionScheduleState: ProductionScheduleState;

  public agInit(params: ProductionScheduleOverviewStatusRendererParams): void {
    this.productionScheduleStatus = params.value;
    this.productionScheduleState = params.state ?? params.data?.state;
    this.withNewIcons = params.withNewIcons;
    this.withSmallSize = params.withSmallSize;
  }

  public refresh(params: any): boolean {
    return false;
  }
}
